<template>
  <b-container fluid>
    <b-row align-h="center" align="center">

      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <b-img src="@/assets/portadapagos.jpg"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12">
            <h4>Da click para continuar con el pago.</h4>
          </b-col>
          <b-col class="mt-3">
            <div>
               <form id="formbbva" method="post" :action="urlAdqr+this.urlAction">  
               <!-- <form id="formbbva" method="post" :action="'https://prepro.adquiracloud.mx/clb/endpoint/'+this.urlAction+'/'">   -->
                <input class="form-submit-button" type="submit" value=" Realizar Pago ">  <br>
                <b class="input-multi"> id_cliente: </b><input  class="input-multi" name="mp_account" v-model="formData.mp_account"><br> 
                <b class="input-multi"> id_producto:</b><input class="input-multi" name="mp_product" v-model="formData.mp_product"><br> 
                <b class="input-multi"> id_orden:</b><input class="input-multi" name="mp_order" v-model="formData.mp_order"><br>
                <b class="input-multi"> referencia:</b><input class="input-multi" name="mp_reference" v-model="formData.mp_reference"><br>               
                <b class="input-multi"> nodo:</b><input class="input-multi" name="mp_node" v-model="formData.mp_node"><br> 
                <b class="input-multi"> concepto:</b><input class="input-multi" name="mp_concept" v-model="formData.mp_concept"><br> 
                <b class="input-multi"> importe:</b><input class="input-multi" name="mp_amount" v-model="formData.mp_amount"><br> 
                <b class="input-multi"> nombre:</b><input class="input-multi" name="mp_custormername" v-model="formData.mp_customername"><br> 
                <b class="input-multi"> moneda:</b><input class="input-multi" name="mp_currency" v-model="formData.mp_currency"><br> 
                <b class="input-multi"> signature:</b><input class="input-multi" name="mp_signature" v-model="formData.mp_signature"><br> 
                <b class="input-multi"> url_exitoso:</b><input class="input-multi" name="mp_urlsuccess" v-model="formData.mp_urlsuccess"><br> 
                <b class="input-multi"> url_no_exitoso:</b><input class="input-multi" name="mp_urlfailure" v-model="formData.mp_urlfailure"><br>                
              </form>
            </div>  
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>

   
  </b-container>
</template>


<script>
import { mapState} from 'vuex';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    urlAdqr: function(){
        var mpio = this.$route.params.municipio;
        return mpio.includes('demo')?'https://prepro.adquiracloud.mx/clb/endpoint/':'https://www.adquiramexico.com.mx/clb/endpoint/';
      },
    
  },
  data(){
    return{
      urlAction:"",
      formData:{
      }
    }
  },
  components: {
  },
  created: function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.formData = {
      "mp_account" : urlParams.get('mp_account'),
      "mp_product" : urlParams.get('mp_product'),
      "mp_order" : urlParams.get('mp_order'),
      "mp_reference" : urlParams.get('mp_reference'),
      "mp_node" : urlParams.get('mp_node'),
      "mp_concept" : urlParams.get('mp_concept'),
      "mp_amount" : urlParams.get('mp_amount'),
      "mp_customername" : urlParams.get('mp_customername'),
      "mp_currency" : urlParams.get('mp_currency'),
      "mp_signature"  : urlParams.get('mp_signature'),
      "mp_urlsuccess" : urlParams.get('mp_urlsuccess'),
      "mp_urlfailure" : urlParams.get('mp_urlfailure'),
    },
    this.urlAction = urlParams.get('mp_action')    

  },
  methods:{
    

  },
  validations:{
    
  }
}
</script>
<style>
  .input-multi{
    color: white;
    border: white;
    font-size : 1px;
  }
  .form-submit-button {
    font-size : 38px;
    padding: 5px;
    background: #28A745;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
    .form-submit-button:hover {
    background: #75C592;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
</style>